import React, { useState } from 'react'
import "../login/Login.scss";

const AdminFooter = () => {
  const [year] = useState(new Date().getFullYear())
  return (
    <>
        <footer className='admin-footer'>
            <p>&copy; {year} <a href="https://data2go.mobi/" target="_blank" rel="noreferrer">data2go</a> | Designed by <a href="https://bluehouse-technology.co.uk" target="_blank" rel="noreferrer">Bluehouse Technology</a></p>
        </footer>
    </>
  )
}
export default AdminFooter